import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DocumentsService } from "../../../../auth/service/documents.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TemplateDocumentService } from "../../../../auth/service/template-document.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";
import { IDocumentCategory } from "app/auth/models/document-id";

@Component({
  selector: "app-form-template",
  templateUrl: "./form-template.component.html",
  styleUrls: ["./form-template.component.scss"],
})
export class FormTemplateComponent implements OnInit {
  public me: ICurrentUser;

  public contentHeader: IContentHeader;

  public formGroup: FormGroup;

  public showErrors: boolean = false;

  public users_list: any = [];

  public categoriesList: IDocumentCategory[] = [];

  public fileDocument: string;

  public fileName: string = null;

  public showEditor: boolean = false;

  public idTemplate: number = null;

  public isEditMode: boolean = false;

  public current_template: any = {};

  constructor(
    public _documentService: DocumentsService,
    private _formBuilder: FormBuilder,
    public _userService: UserService,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _templateDocumentService: TemplateDocumentService,
    private _routerService: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.params.subscribe((params) => {
      this.idTemplate = Number(params.id);
      if (this.idTemplate) {
        this.isEditMode = true;
      }
    });

    this.contentHeader = {
      headerTitle: this.isEditMode ? "MENU.EDIT_FORM_TEMPLATE" : "MENU.ADD_FORM_TEMPLATE",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: this.isEditMode ? "MENU.EDIT_FORM_TEMPLATE" : "MENU.ADD_FORM_TEMPLATE",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.formGroup = this._formBuilder.group({
      title: new FormControl(""),
      category: new FormControl(""),
      text: new FormControl(""),
      file: new FormControl(""),
      available_onboarding: new FormControl(false),
      require_signature: new FormControl(false),
      require_acception: new FormControl({ value: true, disabled: true }),
    });

    this.me = await this._authenticationService.getCurrentUser();
    this.categoriesList = await this._documentService.getCategoriesList().then((categories: any) => {
      const orderedListCategories: any = [];
      categories.map((cat: any) => {
        // push del padre
        orderedListCategories.push(cat);
        if (cat.child) {
          cat.child.map((child: any) => {
            orderedListCategories.push(child);
          });
        }
      });
      return orderedListCategories;
    });
    if (this.isEditMode) {
      this.current_template = await this._templateDocumentService.getTemplate(this.idTemplate);
      this.formGroup.patchValue({
        title: this.current_template.title,
        category: this.current_template.category_id,
        text: this.current_template.dynamic_content,
        available_onboarding: this.current_template.in_onboarding === 1,
        require_signature: this.current_template.require_signature === 1,
      });
      if (this.formGroup.value.text && this.formGroup.value.text.length > 0) {
        this.showEditor = true;
      }
    }

    setTimeout(() => this._utilService.hideLoading());
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async handlerChangeFileInput(event: any) {
    this.fileName = event.target.files[0].name;
    await this._utilService.convertFileToBase64(event, (e: any) => {
      this.fileDocument = e.target.result;
    });
  }

  //Funzione reset valori a seconda di quale tipologia di documento template creare
  selectEditorOrFile() {
    if (this.showEditor) {
      this.formGroup?.controls.text.setValidators([Validators.required, Validators.minLength(2)]);
      this.fileName = "";
      this.fileDocument = "";
      this.formGroup.patchValue({ file: "" });
    } else {
      this.formGroup?.controls.text.setValidators([]);
      this.formGroup.patchValue({
        text: "",
      });
    }
    this.formGroup?.controls.text.updateValueAndValidity();
  }

  async createTemplate() {
    if (!this._authenticationService.hasCapability("create_document_template")) {
      window.history.back();
      return false;
    }

    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }

    const data: any = {
      title: this.formGroup.value.title,
      category: this.formGroup.value.category,
      in_onboarding: this.formGroup.value.available_onboarding ? 1 : 0,
      require_signature: this.formGroup.value.require_signature ? 1 : 0,
      require_acception: 1,
      dynamic_content: this.formGroup.value.text && this.formGroup.value.text.length > 0 ? this.formGroup.value.text : null,
    };

    this._utilService.showLoading();
    await this._templateDocumentService
      .create(data)
      .then(async (response: any) => {
        this._utilService.hideLoading();
        if (!this.showEditor) {
          await this._templateDocumentService
            .upload_file_template(this.fileDocument, response.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_TEMPLATE_DOCUMENT" });
              await this._routerService.navigateByUrl("dashboard/documents-list-template");
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_CREATE_TEMPLATE_DOCUMENT" });
              return false;
            });
        } else {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_TEMPLATE_DOCUMENT" });
          await this._routerService.navigateByUrl("dashboard/documents-list-template");
          return false;
        }
      })
      .catch(async () => {
        await this._utilService.hideLoading;
        await this._utilService.showSWALError({ text: "ERROR_CREATE_TEMPLATE_DOCUMENT" });
      });
  }

  async editTemplate() {
    if (!this._authenticationService.hasCapability("edit_document_template")) {
      window.history.back();
      return false;
    }

    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }

    const data: any = {
      category: this.formGroup.value.category,
      in_onboarding: this.formGroup.value.available_onboarding ? 1 : 0,
      require_signature: this.formGroup.value.require_signature ? 1 : 0,
      require_acception: this.formGroup.value.require_acception || this.formGroup.value.require_signature || this.formGroup.value.available_onboarding ? 1 : 0,
      dynamic_content: this.formGroup.value.text && this.formGroup.value.text.length > 0 ? this.formGroup.value.text : null,
    };

    this._utilService.showLoading();
    await this._templateDocumentService
      .update(this.idTemplate, data)
      .then(async () => {
        this._utilService.hideLoading();
        if (!this.showEditor && this.fileDocument && this.fileDocument.length > 0) {
          await this._templateDocumentService
            .upload_file_template(this.fileDocument, this.idTemplate)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_TEMPLATE_DOCUMENT" });
              await this._routerService.navigateByUrl("dashboard/documents-list-template");
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_EDIT_TEMPLATE_DOCUMENT" });
              return false;
            });
        } else {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_TEMPLATE_DOCUMENT" });
          await this._routerService.navigateByUrl("dashboard/documents-list-template");
          return false;
        }
      })
      .catch(async () => {
        await this._utilService.hideLoading;
        await this._utilService.showSWALError({ text: "ERROR_EDIT_TEMPLATE_DOCUMENT" });
      });
  }
}

// nel caso si volesse ripassare al disabled, qui sotto è riportato il codice
//[disabled]="formGroup.invalid || ( isEditMode ? false : (showEditor ? (!formGroup.value.text || formGroup.value.text.length < 5) : (!formGroup.value.file || formGroup.value.file.length < 5)))"
